import { render, staticRenderFns } from "./FaceBox.vue?vue&type=template&id=03e5b862&scoped=true&lang=pug"
import script from "./FaceBox.vue?vue&type=script&lang=js"
export * from "./FaceBox.vue?vue&type=script&lang=js"
import style0 from "./FaceBox.vue?vue&type=style&index=0&id=03e5b862&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e5b862",
  null
  
)

export default component.exports